import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3eb073a4/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import DataOptionsSection from './shared-data-options-section';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Please direct all questions regarding support, bug fixes, and feature requests to the `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts#core-team"
        }}>{`Carbon Charts core team`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Carbon Charts Vue library</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Install</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Getting started</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Development</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Troubleshooting</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Try Carbon Charts Vue components with CodeSandbox." href="https://codesandbox.io/s/carbon-charts-vue-ghlq0" mdxType="ResourceCard">
    <MdxIcon name="codesandbox" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Carbon Charts Vue" href="https://github.com/carbon-design-system/carbon-charts/tree/master/packages/vue" mdxType="ResourceCard">
      <MdxIcon name="github" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <h2 {...{
      "id": "carbon-charts-vue-library"
    }}>{`Carbon Charts Vue library`}</h2>
    <p>{`The library provides front-end developers & engineers a collection of reusable charting components to build websites and user interfaces. Adopting the library enables developers to use consistent markup, styles, and behavior in prototype and production work.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <h4 {...{
      "id": "using-yarn"
    }}>{`Using yarn`}</h4>
    <br />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ yarn add @carbon/charts @carbon/charts-vue d3
`}</code></pre>
    <h4 {...{
      "id": "if-you-prefer-npm"
    }}>{`If you prefer npm`}</h4>
    <br />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm install --save @carbon/charts @carbon/charts-vue d3
`}</code></pre>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h2>
    <p>{`To start using the `}<inlineCode parentName="p">{`BarChart`}</inlineCode>{` component, try the example below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "path=hello-world.vue",
        "path": "hello-world.vue"
      }}>{`<script>
  import Vue from 'vue';
  import '@carbon/charts/style.css';
  import chartsVue from '@carbon/charts-vue';

  Vue.use(chartsVue);

  export default {
    name: 'HelloWorld',
    components: {},
    data() {
      return {
        stackedBarData: {
          // ...see next section
        },
        stackedBarOptions: {
          // ...see next section
        },
      };
    },
    template:
      '<ccv-bar-chart :data="stackedBarData" :options="stackedBarOptions"></ccv-bar-chart>',
  };
</script>
`}</code></pre>
    <DataOptionsSection mdxType="DataOptionsSection" />
    <h2 {...{
      "id": "development"
    }}>{`Development`}</h2>
    <p>{`Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts/blob/master/CONTRIBUTING.md"
      }}>{`Contribution Guidelines`}</a>{` before starting any work.`}</p>
    <h3 {...{
      "id": "using-the-server"
    }}>{`Using the server`}</h3>
    <p>{`We recommend the use of `}<a parentName="p" {...{
        "href": "https://github.com/storybookjs/storybook/tree/next/app/vue"
      }}>{`Vue Storybook`}</a>{` for developing components.`}</p>
    <h4 {...{
      "id": "start-the-server"
    }}>{`Start the server`}</h4>
    <br />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd packages/vue
yarn run storybook
`}</code></pre>
    <p>{`Open browser to `}<inlineCode parentName="p">{`http://localhost:6006/`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "list-of-available-components"
    }}>{`List of available components`}</h3>
    <p>{`View available components `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts#component-status"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "troubleshooting"
    }}>{`Troubleshooting`}</h2>
    <p>{`If you experience any issues while getting set up with Carbon Charts, please head over to the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts"
      }}>{`GitHub repo`}</a>{` for more guidelines and support. Please `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts/issues"
      }}>{`create an issue`}</a>{` if your issue does not already exist.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      